module.exports = {
    props: ['user', 'teams'],
};



// WEBPACK FOOTER //
// ./vendor/laravel/spark/resources/assets/js/settings/teams.js